import { isValid, format } from 'date-fns';
// transforms a JS date object to this kind of format "2021-05-13"
export const transformDate = (date) => format(date, 'yyyy-MM-dd');

// checks if {date} has this 2021-05-20 format and is valid
export const isValidDay = (dateString) => {
  // First check for the pattern
  const regexDate = /^\d{4}-\d{2}-\d{2}$/;
  return regexDate.test(dateString) && isValid(new Date(dateString));
};

export const isDateTimeInTheFuture = (date, time) => {
  let enteredDT;
  const currentDT = new Date().toISOString();

  try {
    enteredDT = new Date(`${date}T${time}:00`).toISOString();
    return enteredDT > currentDT;
  } catch (e) {
    return false;
  }
};
